import { useNavigate, useParams } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Iconify from '../../ui-component/iconify';
import TableStyle from '../../ui-component/TableStyle';
import { useState } from 'react';
import { Stack, Button, Container, Typography, Box, Card } from '@mui/material';
import * as React from 'react';
import { toast } from 'react-toastify';
import { getApi, patchApi } from 'views/services/api';
import { useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import AddItems from './AddFoodToReservation';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { margin, padding } from '@mui/system';

// ----------------------------------------------------------------------

const Food = () => {
  const params = useParams();
  const navigate = useNavigate();
  const reservationId = params.id;
  const [openAdd, setOpenAdd] = useState(false);
  const [itemsData, setItemsData] = useState([]);
  const [quantityMap, setQuantityMap] = useState({});
  const hotel = JSON.parse(localStorage.getItem('hotelData'));
  const [ItemImg, setItemsImg] = useState('');

  const baseUrl = process.env.REACT_APP_BASE_URL;

  const fetchItemsData = async () => {
    try {
      // const response = await getApi(`api/restaurant/viewallitems/${hotel._id}`);
      const response = await getApi(`api/restaurant/viewallitems/${hotel?.hotelId}`);
      console.log('here response ==> ', response);
      // const items = response?.data?.restaurantData || [];

      const formattedData = response?.data?.restaurantData.map((item) => ({
        ...item,
        itemImage: item.itemImage.split('/').pop()
      }));
      setItemsData(formattedData);

      // Initialize quantity map with initial quantity as 0 for each item
      const initialQuantityMap = {};
      formattedData.forEach((item) => {
        initialQuantityMap[item._id] = 0; // Initialize quantity as 0 for each item
      });
      setQuantityMap(initialQuantityMap);
      setItemsData(items);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchItemsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAdd]);

  const handleCloseAdd = () => setOpenAdd(false);

  const handleAddButtonClick = async () => {
    const selectedItems = itemsData.filter((item) => quantityMap[item._id] > 0);
    const foodItems = selectedItems.map((item) => {
      return {
        id: item._id,
        name: item.itemName,
        price: item.amount,
        quantity: quantityMap[item._id]
      };
    });

    try {
      if (foodItems.length === 0) {
        toast.error('Please select at least one item');
      } else {
        const response = await patchApi(`api/reservation/editfooditems/${reservationId}`, foodItems);
        if (response.status === 200) toast.success('Food Item(s) Added Successfully!');
        navigate(`/dashboard/reservation/view/${reservationId}`);
      }
    } catch (error) {
      console.log(error);
      toast.error('Cannot add food item(s)');
    }
  };

  // Function to handle incrementing quantity for a specific item
  const handleIncrementQuantity = (itemId) => {
    setQuantityMap((prevQuantityMap) => ({
      ...prevQuantityMap,
      [itemId]: (prevQuantityMap[itemId] || 0) + 1
    }));
  };

  // Function to handle decrementing quantity for a specific item
  const handleDecrementQuantity = (itemId) => {
    setQuantityMap((prevQuantityMap) => ({
      ...prevQuantityMap,
      [itemId]: Math.max((prevQuantityMap[itemId] || 0) - 1, 0)
    }));
  };

  const columns = [
    // {
    //   field: 'itemImage',
    //   headerName: 'Item Image',
    //   flex:1,
    //   renderCell: (params) => (
    //     <div>
    //       <img
    //         src={`${baseUrl}api/uploads/restaurant/Item/${params.value}`}
    //         alt="item"
    //         style={{ width: '50%', height: '50%', borderRadius: '10px', }}
    //       />
    //     </div>
    //   )
    // },
    {
      field: 'itemImage',
      headerName: 'Item Image',
      flex: 1,
      renderCell: (params) => (
        <div>
          <img
            src={`${baseUrl}api/uploads/restaurant/Item/${params.value}`}
            alt="item"
            style={{ width: '40px', height: '40px', borderRadius: '10px', objectFit: 'cover' }}
          />
        </div>
      )
    },
    {
      field: 'itemName',
      headerName: 'Item Name',
      flex: 1,
      cellClassName: 'name-column--cell--capitalize'
    },
    {
      field: 'amount',
      headerName: 'Amount',
      flex: 1,
      renderCell: (params) => {
        const itemPrice = params.value;
        const itemQuantity = quantityMap[params.row._id] || 0;
        const totalPrice = itemPrice * itemQuantity;
        return <Box>{hotel?.currencyCode} {totalPrice}</Box>;
      }
    },
    {
      field: 'quantity',
      headerName: 'Quantity',
      flex: 1,
      renderCell: (params) => (
        <Stack direction="row" spacing={1} alignItems="center">
          <IconButton onClick={() => handleIncrementQuantity(params.row._id)}>
            <AddIcon />
          </IconButton>
          {quantityMap[params.row._id] || 0}
          <IconButton onClick={() => handleDecrementQuantity(params.row._id)}>
            <RemoveIcon />
          </IconButton>
        </Stack>
      )
    }
  ];

  return (
    <>
      <AddItems open={openAdd} handleClose={handleCloseAdd} />
      <Container>
        <Stack direction="row" alignItems="center" mb={5} justifyContent={'space-between'}>
          <Typography variant="h4">Food Items</Typography>

          <Stack direction="row" spacing={2}>
            <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleAddButtonClick}>
              Add
            </Button>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              sx={{ marginLeft: 2, color: '#673ab7', borderColor: '#673ab7' }}
              onClick={() => navigate(-1)}
            >
              Back
            </Button>
          </Stack>
        </Stack>
        <TableStyle>
          <Box width="100%">
            <Card style={{ height: '600px', paddingTop: '15px' }}>
              <Typography variant="h4" sx={{ margin: '2px 15px' }}>
                Items ( {itemsData?.length} )
              </Typography>
              <DataGrid
                rows={itemsData}
                columns={columns}
                checkboxSelection
                getRowId={(row) => row._id}
                slots={{ toolbar: GridToolbar }}
                slotProps={{ toolbar: { showQuickFilter: true } }}
                rowHeight={60}
              />
            </Card>
            </Box>
        </TableStyle>
      </Container>
    </>
  );
};

export default Food;
